import React from "react";
import { TAG_LABEL, TAG_STYLE, tagGroup } from "@/lib/instructionTags";

export function TagChips({ tags = [], size = "text-[11px]", testId = "instruction-tags" }) {
  if (!tags.length) return null;
  return (
    <div className={`flex flex-wrap gap-1 ${size}`} data-testid={testId}>
      {tags.map((t) => <span key={t} className={`rounded border px-1.5 py-0.5 font-medium ${TAG_STYLE[tagGroup(t)]}`} data-testid={`tag-${t}`}>{TAG_LABEL[t] || t}</span>)}
    </div>
  );
}
